import React, {Component} from 'react';
const $ = require('jquery');
// $.DataTable = require('datatables.net');
// import 'datatables.net-dt/css/jquery.dataTables.min.css';
// require('datatables.net-buttons/js/dataTables.buttons.min');
const jzip = require('jzip');
// require('datatables.net-buttons/js/buttons.html5.min');
// import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);
const columns = [
  {
    title: '#',
    data: 'ROW_NO'
  },
  {
    title: 'Period',
    data: 'PERIOD_COVERED'
  },
  {
    title: 'Total Scan',
    data: 'TOTAL_SCAN'
  },
  {
    title: 'Total Redeem',
    data: 'TOTAL_REDEEM'
  },
  {
    title: 'Total Balance',
    data: 'TOTAL_BALANCE'
  },
  {
    title: 'Total Reward',
    data: 'TOTAL_REWARD'
  },
  {
    title: 'Grab Food RM 10',
    data: 'Grab Food RM 10'
  },
  {
    title: 'Shopee RM 10',
    data: 'Shopee RM 10'
  },
  {
    title: 'Tmall ¥10',
    data: 'Tmall ¥10'
  },
  {
    title: '7-Eleven $20',
    data: '7-Eleven $20'
  },
  {
    title: '7-ELEVEN NT$100',
    data: '7-ELEVEN NT$100'
  },
  {
    title: 'Name',
    data: 'NAME'
  },
  {
    title: 'Username',
    data: 'USERNAME'
  },
  {
    title: 'Country',
    data: 'COUNTRY_CODE'
  },
  {
    title: 'Company Name',
    data: 'COMPANY_NAME'
  },
  {
    title: 'Age',
    data: 'AGE_RANGE'
  },
  {
    title: 'Gender',
    data: 'GENDER'
  },
  {
    title: 'Sup. Name',
    data: 'SUP_NAME'
  }
];

function reloadTableData(names) {
  console.log("reload: "+names.length);
  const table = $(`#${id}`).DataTable();
  table.clear();
  table.rows.add(names);
  table.draw();
}

function updateTable(names) {
  console.log("update: "+names.length);
  const table = $(`#${id}`).DataTable();
  let dataChanged = false;
  table.rows().every(function () {
    const oldNameData = this.data();
    const newNameData = names.find((nameData) => {
      return nameData.name === oldNameData.name;
    });
    if (oldNameData.nickname !== newNameData.nickname) {
      dataChanged = true;
      this.data(newNameData);
    }
    return true;
  });
  console.log(dataChanged);
  if (dataChanged) {
    table.draw();
  }
}

function hideCols(country) {
  console.log("hide");
  var column;
  column = $(`#${id}`).DataTable().column(6);
  column.visible(false);
  column = $(`#${id}`).DataTable().column(7);
  column.visible(false);
  column = $(`#${id}`).DataTable().column(8);
  column.visible(false);
  column = $(`#${id}`).DataTable().column(9);
  column.visible(false);
  column = $(`#${id}`).DataTable().column(10);
  column.visible(false);

  if (country === 'MY'){
    column = $(`#${id}`).DataTable().column(7);
    column.visible(true);
    column = $(`#${id}`).DataTable().column(6);
    column.visible(true);
  }
  if (country === 'HK' || country === 'MO'){
    column = $(`#${id}`).DataTable().column(9);
    column.visible(true);
  }  
  if (country === 'TW'){
    column = $(`#${id}`).DataTable().column(10);
    column.visible(true);
  }  
  if (country === 'CN'){
    column = $(`#${id}`).DataTable().column(8);
    column.visible(true);
  }
}

class TableMY extends Component {
  componentDidMount() {
    console.log("mount"+this.props.names.length);
    $(`#${id}`).DataTable({
      dom: 'Bfrtip',
      data: this.props.names,
      columns,
      searching: true,
      paging: true,
      ordering: true,
      scrollX: true,
      errMode : 'none',
      buttons: [
        'copy',
        {
          extend: 'csv',
          title: `data_reward_csv_${Date.now()}`
        },
        {
          extend: 'excelHtml5',
          title: `data_reward_excel_${Date.now()}`
        }
      ]
    });
    $.fn.dataTable.ext.errMode = 'none';
  }

  componentWillUnmount() {
    $(`#${id}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.country !== this.props.country) {
      hideCols(nextProps.country);
    }

    if (nextProps.names.length !== this.props.names.length) {
      reloadTableData(nextProps.names);
    } else {
      //updateTable(nextProps.names);
      reloadTableData(nextProps.names);
    }
    return false;
  }

  render() {
    return (
      <div>
        <table ref="main" className="display" id={id} />
      </div>
    );
  }
}
export default TableMY;
